module.exports = __webpack_public_path__ + "static/img/no_date.aa6ac867172f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/com_invitteFriend/no_date.png
// module id = /XTK
// module chunks = 27